import LazyLoad from "vanilla-lazyload";
import Swiper from "swiper";

export default function PhotoSlider(container) {
  const sliderContainer = container;
  const sliderSlidelist = container.querySelectorAll(".js-photo-slider-item");
  const sliderTotalSlide = container.querySelector(
    ".js-photo-slider-pagination-total"
  );
  const sliderCurrentSlide = container.querySelector(
    ".js-photo-slider-pagination-current"
  );
  const popupGallery = document.querySelector(".js-popup-photo-gallery");
  const closeBtn = document.querySelector(".js-popup-photo-gallery-close");
  const galleryTopContainer = document.querySelector(".js-gallery-top");
  const galleryThumbContainer = document.querySelector(".js-gallery-thumbs");
  const galleryTopPagination = document.querySelector(
    ".js-popup-photo-gallery-pagination"
  );

  const bodyElemenet = document.body;
  let windowWidth = bodyElemenet.clientWidth;
  let desctop = false;
  let verticalOrientirStart = false;

  if (windowWidth > 1200) {
    desctop = true;
  }

  const galleryTopLink = document.querySelector(
    ".js-popup-photo-gallery-top-link"
  );
  const galleryTopSizeImg = document.querySelector(
    ".js-popup-photo-gallery-top-size-img"
  );
  const topGalleryImgList = galleryTopContainer.querySelectorAll(
    ".js-popup-photo-gallery-top-img"
  );
  const verticalOrientirClass = "is-vertical";

  if (!desctop) {
    if (bodyElemenet.clientHeight <= bodyElemenet.clientWidth) {
      verticalOrientirImg();
      verticalOrientirStart = true;
    } else {
      horizontalOrientirImg();
      verticalOrientirStart = false;
    }
  }

  window.addEventListener("resize", function resizeWidth() {
    windowWidth = bodyElemenet.clientWidth;
    let verticalOrientirCurrent;

    if (windowWidth > 1200) {
      desctop = true;
    } else {
      desctop = false;
    }

    if (bodyElemenet.clientHeight <= bodyElemenet.clientWidth) {
      if (!desctop && verticalOrientirCurrent !== verticalOrientirStart) {
        verticalOrientirImg();
      }
      verticalOrientirCurrent = true;
    } else {
      if (!desctop && verticalOrientirCurrent !== verticalOrientirStart) {
        horizontalOrientirImg();
      }

      verticalOrientirCurrent = false;
    }

    /* console.log(
      !desctop && verticalOrientirCurrent !== verticalOrientirStart,
      !desctop,
      "start",
      verticalOrientirStart,
      "current",
      verticalOrientirCurrent
    ); */

    verticalOrientirStart = verticalOrientirCurrent;
  });

  function verticalOrientirImg() {
    for (let i = 0, len = topGalleryImgList.length; i < len; i++) {
      const topGalleryImg = topGalleryImgList[i];

      if (!topGalleryImg.classList.contains(verticalOrientirClass)) {
        topGalleryImg.classList.add(verticalOrientirClass);
      }
    }
  }

  function horizontalOrientirImg() {
    for (let i = 0, len = topGalleryImgList.length; i < len; i++) {
      const topGalleryImg = topGalleryImgList[i];

      if (topGalleryImg.classList.contains(verticalOrientirClass)) {
        topGalleryImg.classList.remove(verticalOrientirClass);
      }
    }
  }

  sliderTotalSlide.innerText = sliderSlidelist.length;
  sliderCurrentSlide.innerText = "1";

  /* console.log(
    "sdadad",
    sliderContainer,
    document.getElementsByClassName("js-photo-slider-next")[0]
  ); */
  const nextButtonElement = document.getElementsByClassName(
    "js-photo-slider-next"
  )[0];
  const previousButtonElement = document.getElementsByClassName(
    "js-photo-slider-prev"
  )[0];

  const nextButtonGalleryElement = document.getElementsByClassName(
    "js-popup-photo-gallery-next"
  )[0];
  const previousButtonGalleryElement = document.getElementsByClassName(
    "js-popup-photo-gallery-prev"
  )[0];

  // console.log(sliderContainer, nextButtonElement, previousButtonElement);

  let slider;
  const sliderOptions = {
    init: false,
    slideClass: "js-photo-slider-item",
    wrapperClass: "js-photo-slider-wrapper",
    slidesPerView: "auto",
    // loop: true,
    pagination: {
      el: ".swiper-pagination"
    },
    observer: true,
    navigation: {
      nextEl: nextButtonElement,
      prevEl: previousButtonElement
    },
    on: {
      init() {
        setTimeout(() => {
          initLazyLoad();
        }, 200);
      }
    }
  };

  /* function changeCurrentSlide() {
    console.log("fjfbgdfg");
    if (slider && slider.activeIndex !== undefined) {
      console.log("222");
      sliderCurrentSlide.innerText = slider.activeIndex;
    }
  } */

  const galleryThumb = new Swiper(galleryThumbContainer, {
    // init: false,
    slidesPerView: "auto",
    freeMode: true,
    watchSlidesVisibility: true,
    watchSlidesProgress: true
    /* on: {
      init() {
        setTimeout(() => {
          initLazyLoad();
        }, 200);
      }
    } */
  });

  let galleryTop;
  const galleryTopOptions = {
    slidesPerView: 1,
    speed: 600,
    // spaceBetween: 0,
    init: false,
    // initialSlide: 2,
    navigation: {
      nextEl: nextButtonGalleryElement,
      prevEl: previousButtonGalleryElement
    },
    pagination: {
      el: galleryTopPagination,
      type: "fraction"
    },
    keyboard: {
      enabled: true,
      onlyInViewport: false
    },
    thumbs: {
      swiper: galleryThumb
    },
    on: {
      init() {
        setTimeout(() => {
          initLazyLoad();
        }, 200);
      }
    }
  };

  // initGalleryThumb();
  initSlider();
  initGalleryTop();

  slider.on("slideChange", function changeCurrentSlide() {
    // console.log("slide changed");
    sliderCurrentSlide.innerText = slider.activeIndex + 1;
  });

  function initLazyLoad() {
    const lazyLoad1 = new LazyLoad({
      container,
      elements_selector: ".js-lazy"
    });

    const lazyLoad2 = new LazyLoad({
      container,
      elements_selector: ".js-lazy-bg",
      to_webp: true
    });

    const lazyLoad3 = new LazyLoad({
      container,
      elements_selector: ".js-lazy-webp",
      to_webp: true
    });

    lazyLoad1.loadAll();
    lazyLoad2.loadAll();
    lazyLoad3.loadAll();
  }

  function initSlider() {
    slider = new Swiper(sliderContainer, sliderOptions);
    slider.init();
  }

  function initGalleryTop() {
    galleryTop = new Swiper(galleryTopContainer, galleryTopOptions);
    galleryTop.init();
  }

  galleryTop.on("slideChange", function changeCurrentSlide() {
    const indexActiveSlide = galleryTop.activeIndex;
    const linkDownload = topGalleryImgList[indexActiveSlide].getAttribute(
      "data-download"
    );
    const sizeImg = topGalleryImgList[indexActiveSlide].getAttribute(
      "data-size"
    );

    galleryTopLink.href = linkDownload;
    galleryTopSizeImg.innerText = sizeImg;
  });

  /* function initGalleryThumb() {
    galleryThumb = new Swiper(galleryThumbContainer, galleryThumbOptions);
    galleryThumb.init();
  } */

  for (let i = 0, len = sliderSlidelist.length; i < len; i++) {
    const slide = sliderSlidelist[i];

    openPopupGallery(slide);
  }

  function openPopupGallery(element) {
    element.addEventListener("click", function openPopup() {
      const currentSlide = slider.clickedIndex;

      galleryTop.slideTo(currentSlide, 0, true);

      // console.log("currentSlide", currentSlide);

      if (!popupGallery.classList.contains("is-show")) {
        popupGallery.classList.add("is-show");
      }

      if (!bodyElemenet.classList.contains("no-scrolling")) {
        bodyElemenet.classList.add("no-scrolling");
      }
    });
  }

  closeBtn.addEventListener("click", closePopupGallery);

  function closePopupGallery() {
    if (popupGallery.classList.contains("is-show")) {
      popupGallery.classList.remove("is-show");
    }

    if (bodyElemenet.classList.contains("no-scrolling")) {
      bodyElemenet.classList.remove("no-scrolling");
    }
  }

  window.onkeydown = function onkeydownEsc(event) {
    if (event.keyCode === 27) {
      // console.log("escape pressed");
      closePopupGallery();
    }
  };
}
